function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './index.scss';
import CustomHTMLElement from 'html-element'; ////////// Setup

var CREATE_CLOSE_ICON = null;
export function setup(options) {
  if (typeof options.createCloseIcon === 'function') {
    CREATE_CLOSE_ICON = options.createCloseIcon;
  }
} ////////// Element

import { sendRequest } from 'js-api';

var Popover = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(Popover, _CustomHTMLElement);

  var _super = _createSuper(Popover);

  function Popover() {
    _classCallCheck(this, Popover);

    return _super.apply(this, arguments);
  }

  _createClass(Popover, [{
    key: "_runSetup",
    value: function _runSetup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _get(_getPrototypeOf(Popover.prototype), "_runSetup", this).call(this);

      this.removeOnHide = options.removeOnHide || false;
      this.closeCallback = options.closeCallback || null;
      this.staticOverlay = options.staticOverlay || false;
      this.staticOverlayOption = this.staticOverlay;
      this.currentUrl = null;
      this.createElements();
    }
  }, {
    key: "createElements",
    value: function createElements() {
      var _this = this;

      this.background = document.createElement('a');
      this.background.classList.add('popover__background');
      this.background.addEventListener('click', function (event) {
        return _this.backgroundClicked(event);
      });
      this.appendChild(this.background);
      var wrapper = document.createElement('div');
      wrapper.classList.add('popover__wrapper');
      this.appendChild(wrapper);
      var content = document.createElement('div');
      content.classList.add('popover__content');
      wrapper.appendChild(content); // Header

      this.header = document.createElement('div');
      this.header.classList.add('popover__content__header');
      content.appendChild(this.header);
      this.titleElement = document.createElement('h1');
      this.titleElement.classList.add('popover__content__header__title');

      if (this.title) {
        this.title = this.title;
      }

      this.header.appendChild(this.titleElement);
      this.closeButton = document.createElement('a');
      this.closeButton.classList.add('popover__content__header__close');
      this.closeButton.addEventListener('click', function (event) {
        return _this.closeClicked(event);
      });
      this.header.appendChild(this.closeButton);

      if (CREATE_CLOSE_ICON) {
        this.closeIcon = CREATE_CLOSE_ICON();
        this.closeButton.appendChild(this.closeIcon);
      } // Body


      this.body = document.createElement('div');
      this.body.classList.add('popover__content__body');
      content.appendChild(this.body); // Footer

      this.footer = document.createElement('div');
      this.footer.classList.add('popover__content__footer');
      content.appendChild(this.footer);
    } ////////// Fetching

  }, {
    key: "loadContent",
    value: function () {
      var _loadContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.title = 'Loading...';
                this.currentUrl = null;
                _context.next = 4;
                return sendRequest('GET', url, {
                  headers: {
                    'X-Application-Layout': 'popover'
                  }
                });

              case 4:
                response = _context.sent;
                this.currentUrl = response.url;
                this.displayContent(response.content, response._xhr);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadContent(_x) {
        return _loadContent.apply(this, arguments);
      }

      return loadContent;
    }()
  }, {
    key: "displayContent",
    value: function displayContent(content, xhr) {
      if (typeof xhr !== 'undefined') {
        var staticHeader = xhr.getResponseHeader('X-Popover-Static');

        if (staticHeader === 'true') {
          this.staticOverlay = true;
        } else {
          this.staticOverlay = this.staticOverlayOption;
        }
      } // Update CSRF Data if needed


      var csrfParamMeta = content.querySelector('meta[name=csrf-param]');
      var csrfTokenMeta = content.querySelector('meta[name=csrf-token]');

      if (csrfParamMeta && csrfTokenMeta) {
        var documentCsrfParam = document.querySelector('head meta[name=csrf-param]');
        var documentCsrfToken = document.querySelector('head meta[name=csrf-token]');

        if (documentCsrfParam && documentCsrfToken) {
          documentCsrfParam.content = csrfParamMeta.content;
          documentCsrfToken.content = csrfTokenMeta.content;
        }
      } // Set Popover Title


      var title = content.querySelector('title');

      if (title) {
        this.title = title.innerText;
      } // Update Close Button


      if (this.staticOverlay) {
        this.closeButton.style.display = 'none';

        if (this.title.length === 0) {
          this.header.style.display = 'none';
        }
      } else {
        this.header.style.display = '';
        this.closeButton.style.display = '';
      } // Apply Content Body


      this.body.innerHTML = '';
      var body = content.querySelector('body');
      var popoverBody = content.querySelector('[data-popover-body]');
      var popoverContent = popoverBody || body;
      var children = popoverContent.childNodes;

      for (var i = children.length; i > 0; i--) {
        var child = children[i - 1];
        this.body.insertBefore(child, this.body.firstChild);
      } // Setup Content Captures


      this.captureContent();
      document.triggerEvent('popover:display', this);
      this.triggerEvent('popover:display');
    }
  }, {
    key: "captureContent",
    value: function captureContent() {
      var _this2 = this;

      this.body.querySelectorAll('form[target=_blank]').forEach(function (form) {
        form.addEventListener('submit', function (_event) {
          return _this2.hide();
        });
      });
      this.body.querySelectorAll('a[href][data-popover-link]').forEach(function (link) {
        link.addEventListener('click', function (_event) {
          if (event.metaKey || event.ctrlKey) {
            return true;
          }

          var url = event.currentTarget.href;

          if (!url) {
            return true;
          }

          _this2.loadContent(url);

          event.preventDefault();
          return false;
        });
      });
      this.body.querySelectorAll('[data-popover-close]').forEach(function (button) {
        button.addEventListener('click', function (event) {
          return _this2.closeClicked(event);
        });
      });
    } ////////// Setting Content

  }, {
    key: "title",
    get: function get() {
      return this._title;
    },
    set: function set(title) {
      this._title = title;

      if (this.titleElement) {
        this.titleElement.innerText = title;
      }
    } ////////// State

  }, {
    key: "show",
    value: function show() {
      var _this3 = this;

      // Ensure always at the top
      document.body.appendChild(this);
      this.retainScrolling();
      setTimeout(function () {
        return _this3.classList.add('popover--active');
      });
      document.triggerEvent('popover:show', this);
      this.triggerEvent('popover:show');
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this4 = this;

      this.releaseScrolling();
      this.classList.remove('popover--active');

      if (this.removeOnHide) {
        setTimeout(function () {
          return _this4.remove();
        }, 300);
      }

      if (typeof this.closeCallback === 'function') {
        this.closeCallback();
      }

      document.triggerEvent('popover:hide', this);
      this.triggerEvent('popover:hide');
    } ////////// Events

  }, {
    key: "closeClicked",
    value: function closeClicked(_event) {
      this.hide();
    }
  }, {
    key: "backgroundClicked",
    value: function backgroundClicked(_event) {
      if (this.staticOverlay) {
        return;
      }

      this.hide();
    }
  }]);

  return Popover;
}(CustomHTMLElement);

export { Popover as default };
window.customElements.define('pop-over', Popover);